import { MockUser, User } from "shared-ts-utils-authentication";
import { OidcClaims } from "firefly-chimney-insights-ts-authentication";

export interface DemoBootResult {
  user: User;
}

export const demoUser = new MockUser({
  id: "123",
  email: "jvs@airmont.no",
  name: "Jørund",
  role: "Admin",
  claims: [
    OidcClaims.ReadData,
    OidcClaims.ReadDevices,
    OidcClaims.CreateData,
    OidcClaims.CreateDevices,
  ],
  accessToken: "123",
});

export const bootDemo = async (): Promise<DemoBootResult> => {
  return {
    user: demoUser,
  };
};
